import { render, staticRenderFns } from "./CreateProjectDialog.vue?vue&type=template&id=8c4becc0"
import script from "./CreateProjectDialog.ts?vue&type=script&lang=ts&external"
export * from "./CreateProjectDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./CreateProjectDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports